import { Box } from '@jfs/ui-new'
import { useRoute } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { DatePickerReact } from '../../components/DatePicker'

export const DeviceInvoicesList = () => {
  const route = useRoute()
  const [dates, setDates] = useState(getStartDate())
  const [endDate, setEndDates] = useState(getEndDate())

  useEffect(() => {}, [])

  return (
    <Box>
      <DatePickerReact
        label="Select start date"
        setFieldValue={(_, startDate) => {
          alert(JSON.stringify(dates))
          setDates(startDate)
        }}
        fieldName="startDate"
        value={dates}
      />

      <DatePickerReact
        label="Select end  date"
        setFieldValue={(_, endDate) => {
          alert(JSON.stringify(dates))
          setEndDates(endDate)
        }}
        fieldName="startDate"
        value={endDate}
      />
    </Box>
  )
}

const getStartDate = () => {
  const date = new Date()
  date.setFullYear(date.getFullYear() - 1)
}

const getEndDate = () => {
  return new Date()
}
